// bernie
import { SerializedData, Store } from 'bernie-core';
import { Logger } from 'bernie-logger';

// mobx
import { action, makeObservable } from 'mobx';

// data
import { Product } from 'models';
import { ProductSource } from '../sources';

export class ProductStore extends Store {
  public constructor(private productSource: ProductSource, state: SerializedData = {}, logger: Logger) {
    super(state, logger);

    makeObservable(this, {
      getProducts: action,
      getProduct: action,
    });
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this.productSource, data.productSource);
  }

  public getProducts(programName: string): Product[] {
    return this.productSource.getProducts(programName);
  }

  public getProduct(programName: string, productName: string): Product {
    return this.getProducts(programName).find((product) => (product.name === productName));
  }
}
